"use client";
import React, { useState } from "react";
import TopBarSignedIn from "./../components/common/TopBarSignedIn";
import { searchChannel } from "./../api/youtubeApi";

export const SearchYoutubeChannel = () => {
  const [formData, setFormData] = useState({
    channelName: "",
  });

  const [errors, setErrors] = useState({});
  const [channelInfo, setChannelInfo] = useState([]); // Thêm state để lưu thông tin kênh
  const [isSearching, setIsSearching] = useState(false); // Thêm state để lưu thông tin kênh
  const [selectedChannel, setSelectedChannel] = useState(null); // Thêm state để lưu thông tin kênh

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    // Clear error when field is edited
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: "",
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.channelName.trim()) {
      newErrors.channelName = "Vui lòng nhập tên kênh cần tìm";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSearchChannel = async () => {
    setIsSearching(true)
    setChannelInfo([])
    if (validateForm()) {
      try {
        const result = await searchChannel(formData.channelName);
        setChannelInfo(result);
        setIsSearching(false)
      } catch (error) {
        console.error("Error searching channel:", error);
      }
    }

  };

  return (
    <div className="w-full bg-white min-h-screen">
      <main className="flex flex-col gap-6 p-6 mx-auto w-full max-w-[1272px] max-sm:px-4">
        {/* <header className="mb-8">
          <h1 className="text-2xl font-bold text-gray-800 mb-2">
            Tìm kiếm thông tin - nguồn của kênh youtube
          </h1>
          <p className="text-gray-600">
            Nhập TÊN KÊNH, sau đó bấm TÌM. Danh sách sẽ hiển thị ra 10 kết quả cho từ khóa đó
          </p>
        </header> */}
        <div className="bg-white p-6 rounded-lg shadow-md mb-8">
          <h2 className="text-xl font-semibold mb-4 text-gray-800">
            Tìm kiếm thông tin - nguồn của kênh youtube
          </h2>
          <div className="mb-4">
            <label
              htmlFor="channelName"
              className="block mb-2 text-sm font-medium text-gray-700"
            >
              Nhập tên
            </label>
            <div className="flex items-center">
              <input
                type="text"
                id="channelName"
                name="channelName"
                value={formData.channelName}
                onChange={handleChange}
                className={`bg-gray-50 border ${errors.channelName ? "border-red-500" : "border-gray-300"} text-gray-900 text-sm rounded-lg focus:ring-rose-500 focus:border-rose-500 block w-full p-2.5`}
                placeholder="Ví dụ: Cocomelon"
              />
              <button
                type="button"
                onClick={handleSearchChannel}
                className="ml-2 px-3 py-3 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-blue-300"
              >
                Tìm
              </button>
            </div>
            {errors.channelName && (
              <p className="mt-1 text-sm text-red-500">{errors.channelName}</p>
            )}
            {
              isSearching ? <>
                <p className={"text-center mt-4 text-primary font-bold"}>Đang tìm...</p>
              </> : <>
              {
                channelInfo.length > 0 && (
                  <div className="mt-4 grid grid-cols-1 md:grid-cols-5 lg:grid-cols-5 gap-8">
                    {channelInfo.map((channel, index) => (
                      <div key={index} className={" p-4 rounded-lg shadow hover:shadow-lg " + `${selectedChannel && channel.channelId === selectedChannel.channelId ? "bg-rose-600" : "bg-white"}`} onClick={() => {
                    setSelectedChannel(channel)
                  }}>
                    <img src={channel.thumbnail} alt="Channel Thumbnail" className="w-full h-32 object-cover rounded-lg" />
                    <div className="p-4">
                      <h3 className={"text-sm font-semibold mb-2 " + `${selectedChannel && channel.channelId === selectedChannel.channelId ? "text-white" : "text-primary"}`}>{channel.title}</h3>
                      {/* <p className="text-sm text-gray-600 mb-2">{channel.description}</p> */}
                      <p className={"text-sm mb-2 " + `${selectedChannel && channel.channelId === selectedChannel.channelId ? "text-white" : "text-primary"}`}>Subscribers: {channel.subscriberCount}</p>
                      <p className={"text-sm mb-2 " + `${selectedChannel && channel.channelId === selectedChannel.channelId ? "text-white" : "text-primary"}`}>Videos: {channel.videoCount}</p>
                      <p className={"text-sm mb-2 " + `${selectedChannel && channel.channelId === selectedChannel.channelId ? "text-white" : "text-primary"}`}>Views: {channel.viewCount}</p>
                      <p className={"text-sm mb-2 " + `${selectedChannel && channel.channelId === selectedChannel.channelId ? "text-white" : "text-primary"}`}>Country: {channel.countryName}</p>
                      <p className={"text-sm mb-2 " + `${selectedChannel && channel.channelId === selectedChannel.channelId ? "text-white" : "text-primary"}`}>Quốc gia: {channel.countryTranslate}</p>
                      <a href={channel.youtubeUrl} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline mt-2 block">
                        Mở trên youtube
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            )
          }
        </>
            }

    </div>

        </div >
      </main >
    </div >
  );
};

export default SearchYoutubeChannel;
